import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[sdOnlyNumber]',
  standalone: true,
})
export class OnlyNumberDirective {
  @Input('sdOnlyNumber') numberType: 'integer' | 'float' = 'float';

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const target = event.target as HTMLInputElement;
    const value = target?.value || '';
    const key = event.key || '';
    const chars = this.numberType === 'integer' ? '1234567890' : '1234567890.,';

    if (
      key.length === 1 &&
      !event.ctrlKey &&
      (!chars.includes(key) || (!value && key === '.') || (!value && key === ','))
    ) {
      this.preventDefault(event);
    }
  }

  preventDefault(event: Event): void {
    event.preventDefault();
  }
}
